export default {
  'Resize for': 'Ridimensiona per',
  'Add 10 videos at most': 'Aggiungi 10 video al massimo.',
}